import React from 'react';
import {useAppContext} from 'contexts';
import {JobCBCTable} from 'shared/components/Table/JobCBCTable';
import {useRoomsSidebar} from 'shared/components/Header/helper/useRoomsSidebar';

export const SidebarRightRoom = () => {
    const {tableConfig, dialog} = useRoomsSidebar();
    const {userProfile} = useAppContext();

    return (
        <>
            {userProfile.isAddRoomAvailable ? (
                <JobCBCTable
                    options={tableConfig}
                    className="word-break-cbc-table table-head-inherit-bg"
                />
            ) : null}
            {dialog}
        </>
    );
};
